export default __webpack_public_path__ + "images/WU.9210a2b.png";